import { RecruitApi } from "@/zh-website/src/views/Recruit/api";
import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";

export class RecruitService extends BaseAbstractService {
  static getRecruitList(query) {
    return RecruitApi.getRecruitList(this.request, query);
  }
  static getRecruitDetail(query) {
    return RecruitApi.getRecruitDetail(this.request, query);
  }
  static getCode(query) {
    return RecruitApi.getCode(this.request, query);
  }
  static submitCommitment(query) {
    return RecruitApi.submitCommitment(this.request, query);
  }
  static getPlaceList(params) {
    return RecruitApi.getPlaceList(this.request, params);
  }
}
RecruitService.setRequest(RequestService);
